// import React, { useState, useEffect } from 'react'
// import ReactApexChart from 'react-apexcharts'
// import '../../plant-style.scss'
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import { DatePicker } from '@mui/x-date-pickers/DatePicker'
// import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
// import FullscreenIcon from '@mui/icons-material/Fullscreen'
// import {
//   FetchGraphByminimumguaranteeNew,
//   FetchGraphBysortNew,
// } from '../../../../services/api'
// import dayjs from 'dayjs'
// import Dialog from '@mui/material/Dialog'
// import DialogTitle from '@mui/material/DialogTitle'
// import DialogContent from '@mui/material/DialogContent'
// import CloseIcon from '@mui/icons-material/Close'
// import DialogContentText from '@mui/material/DialogContentText'
// import IconButton from '@mui/material/IconButton'
// import Table from '@mui/material/Table'
// import TableBody from '@mui/material/TableBody'
// import TableCell from '@mui/material/TableCell'
// import TableContainer from '@mui/material/TableContainer'
// import TableHead from '@mui/material/TableHead'
// import TableRow from '@mui/material/TableRow'
// import Paper from '@mui/material/Paper'
// import { saveAs } from 'file-saver'

// import useEnergyAnalysisGraphStyles from './styles'
// import { Grid } from '@mui/material'
// import { LinearBuffer } from '../utils/LinearBuffer'

// const EnergyAnalysisGraph = ({ state, plantContent, token }) => {
//   const classes = useEnergyAnalysisGraphStyles()

//   const [isLoading, setIsLoading] = useState(false)

//   const [technicalFromDate, setTechnicalFromDate] = React.useState(
//     dayjs(new Date()).subtract(29, 'day')
//   )
//   const [technicalToDate, setTechnicalToDate] = React.useState(
//     dayjs(new Date())
//   )
//   const [mapinverterData, setMapinverterData] = React.useState([])
//   const [mapInverterSeries, setMapInverterSeries] = React.useState([])
//   const [inverterviewbutton, setinverterviewbutton] = useState('1m')
//   const [graphType, setGraphType] = useState('etoday')
//   const [selectedDeviceID, setSelectedDeviceID] = useState(1)
//   const [selectedTypeID, setSelectedTypeID] = useState(1)
//   const [selectedButtons, setSelectedButtons] = useState([])
//   const [open, setOpen] = useState(false)
//   const [openTable, setOpenTable] = useState(false)
//   const [screenHeight, setScreenHeight] = useState(window.innerHeight)

//   const PlantID = state?.id

//   const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

//   // Update screen size when the component mounts and when the window is resized
//   useEffect(() => {
//     const handleResize = () => {
//       setScreenHeight(window.innerHeight)
//     }

//     // Attach the resize event listener
//     window.addEventListener('resize', handleResize)

//     // Cleanup the event listener when the component unmounts
//     return () => {
//       window.removeEventListener('resize', handleResize)
//     }
//   }, [])

//   const [lineData, setLineData] = useState({
//     options: {
//       chart: {
//         height: 350,
//         type: 'line',
//         zoom: {
//           enabled: false,
//         },
//         toolbar: {
//           export: {
//             csv: {
//               filename: 'EnergyAnalysis',
//               columnDelimiter: ',',
//               headerCategory: 'Date',
//               headerValue: 'value',
//               dateFormatter(timestamp) {
//                 return new Date(timestamp).toDateString()
//               },
//             },
//             svg: {
//               filename: 'EnergyAnalysis',
//             },
//             png: {
//               filename: 'EnergyAnalysis',
//             },
//           },
//         },
//       },
//       legend: {
//         show: false,
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: 'straight',
//       },
//       title: {
//         align: 'left',
//       },
//       colors: [
//         '#6CB759',
//         '#5968B7',
//         '#dc3545',
//         '#F5B041',
//         '#BB8FCE',
//         '#CCCCFF',
//       ],
//       markers: {
//         size: 2,
//       },
//       grid: {
//         row: {
//           colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//           opacity: 0.5,
//         },
//       },
//       xaxis: {
//         type: 'category',
//         floating: false,
//         tickAmount: 15,
//         tickPlacement: 'on',
//         labels: {
//           show: true,
//           rotate: -45,
//           rotateAlways: true,
//           hideOverlappingLabels: true,
//           showDuplicates: false,
//           trim: false,
//           minHeight: undefined,
//           maxHeight: 120,
//           style: {
//             colors: [],
//             fontSize: '12px',
//             fontFamily: 'Helvetica, Arial, sans-serif',
//             fontWeight: 400,
//             cssClass: 'apexcharts-xaxis-label',
//           },
//           offsetX: 0,
//           offsetY: 0,
//           format: 'dd/MM',
//           formatter: function (value, timestamp, opts) {
//             return dayjs(value).format('DD-MM')
//           },
//           datetimeUTC: false,
//           datetimeFormatter: {
//             year: 'yyyy',
//             month: "MMM 'yy",
//             day: 'dd MMM',
//             hour: 'HH:mm',
//           },
//         },
//       },
//       tooltip: {
//         enabled: true,
//         x: {
//           show: true,
//           format: 'dd MMM',
//           formatter: function (value, opts) {
//             return dayjs(
//               opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
//                 ?.x
//             ).format('DD-MMMM-YYYY')
//           },
//         },
//       },
//     },
//   })

//   const DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.id

//   useEffect(() => {
//     setSelectedDeviceID(DEVID)
//     setSelectedButtons([`ActualGeneration`])
//     handleSelectInverter(
//       'etoday',
//       '1m',
//       DEVID,
//       selectedTypeID,
//       technicalFromDate,
//       technicalToDate
//     )
//   }, [DEVID])

//   useEffect(() => {
//     handleChangePreiod(inverterviewbutton, technicalFromDate)
//   }, [inverterviewbutton, technicalFromDate, technicalToDate])

//   const handleOpen = () => {
//     setOpen(true)
//   }

//   const handleClose = () => {
//     setOpen(false)
//   }

//   const handleSelectInverter = (
//     type,
//     duration,
//     deviceID,
//     typeID,
//     selectedDate,
//     selectedtoDate
//   ) => {
//     let subtraction
//     let subType
//     let graphName
//     let TechnicalFromDate
//     let TechnicalTodate
//     switch (duration) {
//       case 'year':
//         subtraction = 11
//         subType = 'month'
//         TechnicalFromDate = selectedDate
//         TechnicalTodate = 'all'
//         break
//       case '1m':
//         subtraction = 0
//         subType = 'month'
//         TechnicalFromDate = selectedDate
//         TechnicalTodate = 'all'
//         break
//       case '3m':
//         subtraction = 2
//         subType = 'month'
//         TechnicalFromDate = selectedDate
//         TechnicalTodate = 'all'
//         break
//       case '6m':
//         subtraction = 5
//         subType = 'month'
//         TechnicalFromDate = selectedDate
//         TechnicalTodate = 'all'
//         break
//       case 'mtd':
//         subtraction = 0
//         subType = 'month'
//         TechnicalFromDate = dayjs(new Date())
//         TechnicalTodate = 'all'
//         break
//       case 'ytd':
//         subtraction = 0
//         subType = 'month'
//         TechnicalFromDate = dayjs(new Date())
//         TechnicalTodate = 'all'
//         break
//       case 'custom':
//         subtraction = 0
//         subType = 'month'
//         TechnicalFromDate = dayjs(selectedDate).format('YYYY-MM-DD')
//         TechnicalTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
//         break
//       default:
//         break
//     }

//     const yearData = dayjs(technicalFromDate).subtract(subtraction, subType)
//     const sortDate = dayjs(TechnicalFromDate).format('YYYY-MM-DD')

//     if (type === 'MinimumGuaranteed') {
//       setIsLoading(true)
//       FetchGraphByminimumguaranteeNew(
//         PlantID,
//         sortDate,
//         token,
//         duration,
//         TechnicalTodate
//       ).then((resp) => {
//         if (resp?.data) {
//           const newEnergyData = resp?.data.map((obj) => ({
//             x: obj.x,
//             y: Number(parseFloat(obj.y).toFixed(1)),
//           }))

//           let devtype
//           if (type === 'etoday') {
//             devtype = 'etoday'
//             // devtype = 'ActualGeneration'
//           } else if (type === 'MinimumGuaranteed') {
//             devtype = 'MinimumGuaranteed'
//           }
//           setMapInverterSeries((prevSeries) => {
//             const existingObject = prevSeries.find(
//               (obj) => obj.name === `${devtype}`
//             )

//             if (existingObject) {
//               const updatedObject = {
//                 ...existingObject,
//                 data: newEnergyData,
//               }

//               return prevSeries.map((obj) =>
//                 obj.name === `${devtype}` ? updatedObject : obj
//               )
//             } else {
//               const newObject = {
//                 name: `${devtype}`,
//                 data: newEnergyData,
//               }
//               setIsLoading(false)

//               return [...prevSeries, newObject]
//             }
//           })
//         } else {
//         }
//       })
//     } else {
//       setIsLoading(true)

//       FetchGraphBysortNew(
//         PlantID,
//         sortDate,
//         duration,
//         type,
//         token,
//         TechnicalTodate,
//         'all',
//         'all'
//       ).then((resp) => {
//         if (resp?.data) {
//           const newInverterData = resp?.data.map((obj) => ({
//             x: obj.x,
//             y: Number(parseFloat(obj.y).toFixed(1)),
//           }))
//           let devtype
//           if (type === 'etoday') {
//             devtype = 'ActualGeneration'
//           } else if (type === 'MinimumGuaranteed') {
//             devtype = 'MinimumGuaranteed'
//           } else if (type === 'expectedgeneration') {
//             devtype = 'ExpectedGeneration'
//           }

//           setMapinverterData(newInverterData)
//           setMapInverterSeries((prevSeries) => {
//             const existingObject = prevSeries.find(
//               (obj) => obj.name === `${devtype}`
//             )

//             if (existingObject) {
//               const updatedObject = {
//                 ...existingObject,
//                 data: newInverterData,
//               }

//               return prevSeries.map((obj) =>
//                 obj.name === `${devtype}` ? updatedObject : obj
//               )
//             } else {
//               const newObject = {
//                 name: `${devtype}`,
//                 data: newInverterData,
//               }
//               setIsLoading(false)

//               return [...prevSeries, newObject]
//             }
//           })
//         } else {
//         }
//       })
//     }
//   }

//   const separateValues = (str) => {
//     const [label, value] = str.split(' ') // Split the string into two parts using the space as a separator
//     return { label, value }
//   }

//   const handleChangePreiod = (Period, selectedDate) => {
//     selectedButtons.map((item) => {
//       const { label, value } = separateValues(item)

//       let devtype
//       if (label === 'ActualGeneration') {
//         devtype = 'etoday'
//       } else if (label === 'MinimumGuaranteed') {
//         devtype = 'MinimumGuaranteed'
//       } else if (label === 'ExpectedGeneration') {
//         devtype = 'expectedgeneration'
//       }
//       handleSelectInverter(
//         devtype,
//         Period,
//         selectedDeviceID,
//         selectedTypeID,
//         selectedDate,
//         technicalToDate
//       )
//     })
//   }

  

//     const handleChooseDate = (value, type) => {
//   if (type === 'from') {
//     setTechnicalFromDate(value);
//   } else if (type === 'to') {
//     setTechnicalToDate(value);
//   }
//   // Ensure 'to' date is not before 'from' date
//   if (type === 'to' && dayjs(value).isBefore(technicalFromDate)) {
//     setTechnicalFromDate(value);
//     setTechnicalToDate(technicalFromDate);
//   }
// };

//   const handleselectButton = (ButtonType) => {
//     switch (ButtonType) {
//       case 'year':
//         const yearData = dayjs(technicalFromDate).add(11, 'month')
//         const currentDate1y = dayjs()
//         const isFuture1y = yearData.isAfter(currentDate1y)
//         if (isFuture1y) {
//           const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
//           setTechnicalFromDate(previous1yData)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('year')
//           handleChangePreiod('year', previous1yData)
//         } else {
//           const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
//           setTechnicalFromDate(previous1yData)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('year')
//           handleChangePreiod('year', previous1yData)
//         }

//         break
//       case '1m':
//         const monthData = dayjs(technicalFromDate).add(29, 'day')
//         const currentDate1 = dayjs()
//         const isFuture1 = monthData.isAfter(currentDate1)
//         if (isFuture1) {
//           const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
//           setTechnicalFromDate(previous1Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('1m')
//           handleChangePreiod('1m', previous1Data)
//         } else {
//           const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
//           setTechnicalFromDate(previous1Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('1m')
//           handleChangePreiod('1m', previous1Data)
//         }
//         break
//       case '3m':
//         const month3Data = dayjs(technicalFromDate).add(2, 'month')
//         const currentDate = dayjs()
//         const isFuture = month3Data.isAfter(currentDate)
//         if (isFuture) {
//           const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
//           setTechnicalFromDate(previous3Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('3m')
//           handleChangePreiod('3m', previous3Data)
//         } else {
//           const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
//           setTechnicalFromDate(previous3Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('3m')
//           handleChangePreiod('3m', previous3Data)
//         }
//         break
//       case '6m':
//         const month6Data = dayjs(technicalFromDate).add(5, 'month')
//         const currentDate6 = dayjs()
//         const isFuture6 = month6Data.isAfter(currentDate6)
//         if (isFuture6) {
//           const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
//           setTechnicalFromDate(previous6Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('6m')
//           handleChangePreiod('6m', previous6Data)
//         } else {
//           const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
//           setTechnicalFromDate(previous6Data)
//           setTechnicalToDate(dayjs(new Date()))
//           setinverterviewbutton('6m')
//           handleChangePreiod('6m', previous6Data)
//         }
//         break
//       case 'mtd':
//         const firstDateOfMonth = dayjs(new Date()).startOf('month')
//         const mtdData = dayjs(new Date()).subtract(1, 'month')
//         setTechnicalFromDate(firstDateOfMonth)
//         setTechnicalToDate(dayjs(new Date()))
//         setinverterviewbutton('mtd')
//         handleChangePreiod('mtd', dayjs(new Date()))

//         break
//       case 'ytd':
//         const firstDateOfYear = dayjs(new Date()).startOf('year')
//         const ytdData = dayjs(new Date()).subtract(1, 'year')
//         setTechnicalFromDate(firstDateOfYear)
//         setTechnicalToDate(dayjs(new Date()))
//         setinverterviewbutton('ytd')
//         handleChangePreiod('ytd', dayjs(new Date()))

//         break
//       case 'custom':
//         const customFromdate = dayjs(technicalFromDate).format('YYYY-MM-DD')
//         const customTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
//         setinverterviewbutton('custom')
//         handleChangePreiod('custom', customFromdate, customTodate)
//         break
//       default:
//         break
//     }
//   }

//   const handleInverterViewSort = (type) => {
//     if (type === 'year') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'MMMM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('MMM-YY')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'MMMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('DD-MM-YYYY')
//               },
//             },
//           },
//         },
//       })
//       handleselectButton('year')
//     } else if (type === '1m') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             tickAmount: 15,
//             tickPlacement: 'on',
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'dd/MM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('DD-MM')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'dd MMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('DD-MMMM-YYYY')
//               },
//             },
//           },
//         },
//       })

//       handleselectButton('1m')
//     } else if (type === '3m') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'MMMM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('MM-YY')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'MMMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('MM-YYYY')
//               },
//             },
//           },
//         },
//       })

//       handleselectButton('3m')
//     } else if (type === '6m') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'MMMM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('MMM-YY')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'MMMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('MMMM-YYYY')
//               },
//             },
//           },
//         },
//       })

//       handleselectButton('6m')
//     } else if (type === 'ytd') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'MMMM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('MMM-YY')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'MMMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('MMMM-YYYY')
//               },
//             },
//           },
//         },
//       })
//       handleselectButton('ytd')
//     } else if (type === 'mtd') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             tickAmount: 15,
//             tickPlacement: 'on',
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'dd/MM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('DD-MM')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'dd MMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('DD-MMM-YYYY')
//               },
//             },
//           },
//         },
//       })
//       handleselectButton('mtd')
//     } else if (type === 'custom') {
//       setLineData({
//         options: {
//           chart: {
//             height: 350,
//             type: 'line',
//             zoom: {
//               enabled: false,
//             },
//             toolbar: {
//               export: {
//                 csv: {
//                   filename: 'EnergyAnalysis',
//                   columnDelimiter: ',',
//                   headerCategory: 'Date',
//                   headerValue: 'value',
//                   dateFormatter(timestamp) {
//                     return new Date(timestamp).toDateString()
//                   },
//                 },
//                 svg: {
//                   filename: 'EnergyAnalysis',
//                 },
//                 png: {
//                   filename: 'EnergyAnalysis',
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           stroke: {
//             curve: 'straight',
//           },
//           title: {
//             align: 'left',
//           },
//           colors: [
//             '#6CB759',
//             '#5968B7',
//             '#dc3545',
//             '#F5B041',
//             '#BB8FCE',
//             '#CCCCFF',
//           ],
//           markers: {
//             size: 2,
//           },
//           grid: {
//             row: {
//               colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
//               opacity: 0.5,
//             },
//           },
//           xaxis: {
//             type: 'category',
//             floating: false,
//             tickAmount: 15,
//             tickPlacement: 'on',
//             labels: {
//               show: true,
//               rotate: -45,
//               rotateAlways: true,
//               hideOverlappingLabels: true,
//               showDuplicates: false,
//               trim: false,
//               minHeight: undefined,
//               maxHeight: 120,
//               style: {
//                 colors: [],
//                 fontSize: '12px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 400,
//                 cssClass: 'apexcharts-xaxis-label',
//               },
//               offsetX: 0,
//               offsetY: 0,
//               format: 'dd/MM',
//               formatter: function (value, timestamp, opts) {
//                 return dayjs(value).format('DD/MM')
//               },
//               datetimeUTC: false,
//               datetimeFormatter: {
//                 year: 'yyyy',
//                 month: "MMM 'yy",
//                 day: 'dd MMM',
//                 hour: 'HH:mm',
//               },
//             },
//           },
//           tooltip: {
//             enabled: true,
//             x: {
//               show: true,
//               format: 'dd MMM',
//               formatter: function (value, opts) {
//                 return dayjs(
//                   opts.w.config.series[opts.seriesIndex].data[
//                     opts.dataPointIndex
//                   ].x
//                 ).format('DD-MM-YYYY')
//               },
//             },
//           },
//         },
//       })

//       handleselectButton('custom')
//     }
//   }

//   const handleButtonClick = (buttonName, deviceID, typeID) => {
//     if (selectedButtons.includes(`${buttonName}`)) {
//       // If the button is already selected, remove it from the selected buttons
//       setSelectedButtons(
//         selectedButtons.filter((btn) => btn !== `${buttonName}`)
//       )

//       setMapInverterSeries(
//         (prevSeries) => prevSeries.filter((obj) => obj.name !== `${buttonName}`) // Specify the name of the object to remove
//       )
//     } else {
//       // If the button is not selected, check if the limit of 2 buttons is reached
//       // if (selectedButtons.length < 2) {
//       // Add the button to the selected buttons
//       setSelectedButtons([...selectedButtons, `${buttonName}`])
//       setSelectedDeviceID(deviceID)
//       setSelectedTypeID(typeID)
//       let devtype
//       if (buttonName === 'ActualGeneration') {
//         devtype = 'etoday'
//       } else if (buttonName === 'MinimumGuaranteed') {
//         devtype = 'MinimumGuaranteed'
//       } else if (buttonName === 'ExpectedGeneration') {
//         devtype = 'expectedgeneration'
//       }
//       setGraphType(devtype)
//       handleSelectInverter(
//         devtype,
//         inverterviewbutton,
//         deviceID,
//         typeID,
//         technicalFromDate,
//         technicalToDate
//       )
//     }
//   }

//   const columns = [
//     { field: 'x', headerName: 'Date', width: 100 },
//     { field: 'y', headerName: 'Yield', width: 100 },
//   ]

//   const exportToCSV = (rows) => {
//     const headings = ['Date', ...rows.map((item) => item.name)] // Add 'Date' and 'name' properties as headings
//     const csvContent = [headings.join(',')]

//     const allDates = new Set()
//     rows.forEach((item) =>
//       item.data.forEach((row) =>
//         allDates.add(dayjs(row.x).format('DD-MM-YYYY'))
//       )
//     )

//     allDates.forEach((date) => {
//       const rowData = [date]
//       rows.forEach((item) => {
//         const dataForDate = item.data.find(
//           (row) => dayjs(row.x).format('DD-MM-YYYY') === date
//         )
//         rowData.push(dataForDate ? dataForDate.y : 0)
//       })
//       csvContent.push(rowData.join(','))
//     })

//     const blob = new Blob([csvContent.join('\n')], {
//       type: 'text/csv;charset=utf-8',
//     })
//     saveAs(blob, 'EnergyAnalysis.csv')
//   }
//   const datePickerStyle = {
//     width: '130px',
//   }

//   const dynamicHeadings = mapInverterSeries.map((item) => item.name)

//   return (
//     <div className={classes.root}>
//       <div
//         className="graph_bg mb_10"
//         style={{ minHeight: '510px', backgroundColor: 'white' }}
//       >
//         <div className="align_btw mb_6">
//           <div>
//             <div className="h_txt1">Energy Analysis</div>
//           </div>

//           <div>
//             <div className="align_end">
//               <div class="check_graph mr_8">
//                 <input
//                   id="EnergyAnalysisGraph"
//                   type="checkbox"
//                   checked={openTable}
//                   onChange={(e) => setOpenTable(!openTable)}
//                 />
//                 <label for="EnergyAnalysisGraph"></label>
//               </div>
//               <div className="mr_8">
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DemoContainer components={['DatePicker']}>
//                     <div style={datePickerStyle}>
//                       <DatePicker
//                         style={{ width: '120px !important' }}
//                         label="From Date"
//                         minDate={dayjs(new Date()).subtract(2, 'year')}
//                         maxDate={
//                           inverterviewbutton === 'custom'
//                             ? technicalToDate
//                             : dayjs()
//                         }
//                         className={classes.datePicker}
//                         format="DD-MM-YYYY"
//                         value={technicalFromDate}
//                         onChange={(value) => handleChooseDate(value, 'from')}
//                       />
//                     </div>
//                   </DemoContainer>
//                 </LocalizationProvider>
//               </div>
//               <div className="mr_8">
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DemoContainer components={['DatePicker']}>
//                     <div style={datePickerStyle}>
//                       <DatePicker
//                         style={{ width: '120px !important' }}
//                         label="To Date"
//                         minDate={
//                           inverterviewbutton === 'custom'
//                             ? technicalFromDate
//                             : dayjs(new Date()).subtract(2, 'year')
//                         }
//                         maxDate={dayjs()}
//                         className={classes.datePicker}
//                         format="DD-MM-YYYY"
//                         value={technicalToDate}
//                         onChange={(value) => handleChooseDate(value, 'to')}
//                       />
//                     </div>
//                   </DemoContainer>
//                 </LocalizationProvider>
//               </div>

//               {openTable && (
//                 <div className="mr_8">
//                   <VerticalAlignBottomIcon
//                     className="i_clr pointer"
//                     onClick={() => exportToCSV(mapInverterSeries)}
//                   />
//                 </div>
//               )}
//               <div>
//                 <FullscreenIcon
//                   className="i_clr pointer"
//                   onClick={handleOpen}
//                 />
//               </div>

//               <Dialog fullScreen open={open} onClose={handleClose}>
//                 <IconButton
//                   onClick={handleClose}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: 8,
//                     color: (theme) => theme.palette.grey[500],
//                   }}
//                 >
//                   <CloseIcon />
//                 </IconButton>
//                 <DialogTitle></DialogTitle>
//                 <DialogContent>
//                   <DialogContentText>
//                     <div className="graph_bg">
//                       <div className="align_btw mb_10">
//                         <div>
//                           <div className="h1">Energy Analysis</div>
//                         </div>

//                         <div className={classes.root}>
//                           <div className="align_end">
//                             <div class="check_graph mr_8">
//                               <input
//                                 id="EnergyAnalysisGraph2"
//                                 type="checkbox"
//                                 checked={openTable}
//                                 onChange={(e) => setOpenTable(!openTable)}
//                               />
//                               <label for="EnergyAnalysisGraph2"></label>
//                             </div>
//                             <div className="mr_8">
//                               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DemoContainer components={['DatePicker']}>
//                                   <DatePicker
//                                     label="From Date"
//                                     minDate={dayjs(new Date()).subtract(
//                                       2,
//                                       'year'
//                                     )}
//                                     maxDate={
//                                       inverterviewbutton === 'custom'
//                                         ? technicalToDate
//                                         : dayjs()
//                                     }
//                                     format="DD-MM-YYYY"
//                                     value={technicalFromDate}
//                                     onChange={(value) =>
//                                       handleChooseDate(value, 'from')
//                                     }
//                                   />
//                                 </DemoContainer>
//                               </LocalizationProvider>
//                             </div>
//                             <div className="mr_8">
//                               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DemoContainer components={['DatePicker']}>
//                                   <DatePicker
//                                     label="To Date"
//                                     minDate={
//                                       inverterviewbutton === 'custom'
//                                         ? technicalFromDate
//                                         : dayjs(new Date()).subtract(2, 'year')
//                                     }
//                                     maxDate={dayjs()}
//                                     format="DD-MM-YYYY"
//                                     value={technicalToDate}
//                                     onChange={(value) =>
//                                       handleChooseDate(value, 'to')
//                                     }
//                                   />
//                                 </DemoContainer>
//                               </LocalizationProvider>
//                             </div>

//                             {openTable && (
//                               <div className="mr_8">
//                                 <VerticalAlignBottomIcon
//                                   className="i_clr pointer"
//                                   onClick={() =>
//                                     exportToCSV(
//                                       mapInverterSeries[0]?.data,
//                                       columns
//                                     )
//                                   }
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       <div className="align_btw mb_6">
//                         <div
//                           className=""
//                           style={{
//                             width: '30%',
//                             display: 'flex',
//                             flexDirection: 'row',
//                           }}
//                         >
//                           <div
//                             className="head_button mr_8"
//                             style={
//                               isButtonSelected(`ActualGeneration`)
//                                 ? {
//                                     backgroundColor: 'rgba(89, 104, 183, 0.25)',
//                                   }
//                                 : {}
//                             }
//                             onClick={() =>
//                               handleButtonClick(`ActualGeneration`, '', 1)
//                             }
//                           >
//                             Actual Generation
//                           </div>
//                           <div
//                             className="head_button mr_8"
//                             style={
//                               isButtonSelected(`MinimumGuaranteed`)
//                                 ? {
//                                     backgroundColor: 'rgba(89, 104, 183, 0.25)',
//                                   }
//                                 : {}
//                             }
//                             onClick={() =>
//                               handleButtonClick(`MinimumGuaranteed`, '', 1)
//                             }
//                           >
//                             Minimum Guaranteed
//                           </div>
//                           <div
//                             className="head_button mr_8"
//                             style={
//                               isButtonSelected(`ExpectedGeneration`)
//                                 ? {
//                                     backgroundColor: 'rgba(89, 104, 183, 0.25)',
//                                   }
//                                 : {}
//                             }
//                             onClick={() =>
//                               handleButtonClick(`ExpectedGeneration`, '', 1)
//                             }
//                           >
//                             Expected Generation
//                           </div>
//                         </div>

//                         <div>
//                           <div
//                             className={
//                               inverterviewbutton === 'custom'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('custom')}
//                           >
//                             CUST
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === 'ytd'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('ytd')}
//                           >
//                             YTD
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === 'mtd'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('mtd')}
//                           >
//                             MTD
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === 'year'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('year')}
//                           >
//                             1 Y
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === '6m'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('6m')}
//                           >
//                             6 M
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === '3m'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('3m')}
//                           >
//                             3 M
//                           </div>
//                           <div
//                             className={
//                               inverterviewbutton === '1m'
//                                 ? 'day_s_bottomline'
//                                 : 'day_s_b '
//                             }
//                             onClick={() => handleInverterViewSort('1m')}
//                           >
//                             1 M
//                           </div>
//                         </div>
//                       </div>
//                       {openTable ? (
//                         <div style={{ maxHeight: '360px', overflow: 'auto' }}>
//                           <TableContainer component={Paper}>
//                             <Table aria-label="simple table">
//                               <TableHead>
//                                 <TableRow>
//                                   <TableCell>Date</TableCell>
//                                   {dynamicHeadings?.map((heading, index) => (
//                                     <TableCell key={index}>{heading}</TableCell>
//                                   ))}
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {mapInverterSeries?.[0]?.data?.map(
//                                   (row, rowIndex) => (
//                                     <TableRow key={rowIndex}>
//                                       <TableCell>
//                                         {dayjs(row.x).format('DD-MM-YYYY')}
//                                       </TableCell>
//                                       {mapInverterSeries?.map((item, index) => (
//                                         <TableCell key={index}>
//                                           {item.data.find(
//                                             (entry) => entry.x === row.x
//                                           )?.y || 0}
//                                         </TableCell>
//                                       ))}
//                                     </TableRow>
//                                   )
//                                 )}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                         </div>
//                       ) : (
//                         <div>
//                           <div>
//                             <div
//                               style={{
//                                 color: '#5968B7',
//                                 fontSize: '12px',
//                                 marginLeft: '5px',
//                               }}
//                             >
//                               kWh
//                             </div>
//                           </div>
//                           <div id="chart">
//                             <ReactApexChart
//                               options={lineData.options}
//                               series={mapInverterSeries}
//                               legend={lineData.legend}
//                               type="line"
//                               height={screenHeight - 200}
//                             />
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </DialogContentText>
//                 </DialogContent>
//               </Dialog>
//             </div>
//           </div>
//         </div>
//         <div className="align_btw mb_6">
//           <Grid container>
//             <Grid md={6}>
//               <div className=" ">
//                 <div>
//                   <div
//                     className={`head_button`}
//                     style={
//                       isButtonSelected(`ActualGeneration`)
//                         ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
//                         : {}
//                     }
//                     onClick={() => handleButtonClick(`ActualGeneration`, '', 1)}
//                   >
//                     Actual Generation
//                   </div>
//                   <div
//                     className={`head_button`}
//                     style={
//                       isButtonSelected(`MinimumGuaranteed`)
//                         ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
//                         : {}
//                     }
//                     onClick={() =>
//                       handleButtonClick(`MinimumGuaranteed`, '', 1)
//                     }
//                   >
//                     Minimum Guaranteed
//                   </div>
//                   <div
//                     className={`head_button`}
//                     style={
//                       isButtonSelected(`ExpectedGeneration`)
//                         ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
//                         : {}
//                     }
//                     onClick={() =>
//                       handleButtonClick(`ExpectedGeneration`, '', 1)
//                     }
//                   >
//                     Expected Generation
//                   </div>
//                 </div>
//               </div>
//             </Grid>
//             <Grid md={6} style={{ display: 'flex', justifyContent: 'end' }}>
//               <div>
//                 <div
//                   className={
//                     inverterviewbutton === 'custom'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('custom')}
//                 >
//                   CUST
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === 'ytd'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('ytd')}
//                 >
//                   YTD
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === 'mtd'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('mtd')}
//                 >
//                   MTD
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === 'year'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('year')}
//                 >
//                   1 Y
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === '6m'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('6m')}
//                 >
//                   6 M
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === '3m'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('3m')}
//                 >
//                   3 M
//                 </div>
//                 <div
//                   className={
//                     inverterviewbutton === '1m'
//                       ? 'day_s_bottomline'
//                       : 'day_s_b '
//                   }
//                   onClick={() => handleInverterViewSort('1m')}
//                 >
//                   1 M
//                 </div>
//               </div>
//             </Grid>
//           </Grid>
//         </div>

//         {isLoading ? (
//           <div
//             style={{
//               padding: '100px',
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               minHeight: '200px',
//               marginTop: '100px',
//             }}
//           >
//             <LinearBuffer />
//           </div>
//         ) : openTable ? (
//           <div style={{ maxHeight: '360px', overflow: 'auto' }}>
//             <TableContainer component={Paper}>
//               <Table aria-label="simple table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Date</TableCell>
//                     {dynamicHeadings?.map((heading, index) => (
//                       <TableCell key={index}>{heading}</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {mapInverterSeries?.[0]?.data?.map((row, rowIndex) => (
//                     <TableRow key={rowIndex}>
//                       <TableCell>{dayjs(row.x).format('DD-MM-YYYY')}</TableCell>
//                       {mapInverterSeries?.map((item, index) => (
//                         <TableCell key={index}>
//                           {item.data.find((entry) => entry.x === row.x)?.y || 0}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </div>
//         ) : (
//           <div>
//             <div>
//               <div
//                 style={{
//                   color: '#5968B7',
//                   fontSize: '12px',
//                   marginLeft: '5px',
//                 }}
//               >
//                 kWh
//               </div>
//             </div>
//             <div id="chart">
//               <ReactApexChart
//                 options={lineData.options}
//                 series={mapInverterSeries}
//                 legend={lineData.legend}
//                 type="line"
//                 height={350}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   )
// }

// EnergyAnalysisGraph.propTypes = {}

// export default EnergyAnalysisGraph


import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import '../../plant-style.scss'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import {
  FetchGraphByminimumguaranteeNew,
  FetchGraphBysortNew,
  fetchGraphV2Data
} from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { saveAs } from 'file-saver'

import useEnergyAnalysisGraphStyles from './styles'
import { Grid } from '@mui/material'
import { LinearBuffer } from '../utils/LinearBuffer'

const EnergyAnalysisGraph = ({ state, plantContent, token }) => {
  const classes = useEnergyAnalysisGraphStyles()

  const [isLoading, setIsLoading] = useState(false)

  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [mapinverterData, setMapinverterData] = React.useState([])
  const [mapInverterSeries, setMapInverterSeries] = React.useState([])
  const [inverterviewbutton, setinverterviewbutton] = useState('1m')
  const [graphType, setGraphType] = useState('etoday')
  const [selectedDeviceID, setSelectedDeviceID] = useState(1)
  const [selectedTypeID, setSelectedTypeID] = useState(1)
  const [selectedButtons, setSelectedButtons] = useState([])
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)

  const PlantID = state?.id

  const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

  // Update screen size when the component mounts and when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }

    // Attach the resize event listener
    window.addEventListener('resize', handleResize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const [lineData, setLineData] = useState({
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          export: {
            csv: {
              filename: 'EnergyAnalysis',
              columnDelimiter: ',',
              headerCategory: 'Date',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            svg: {
              filename: 'EnergyAnalysis',
            },
            png: {
              filename: 'EnergyAnalysis',
            },
          },
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      title: {
        align: 'left',
      },
      colors: [
        '#6CB759',
        '#5968B7',
        '#dc3545',
        '#F5B041',
        '#BB8FCE',
        '#CCCCFF',
      ],
      markers: {
        size: 2,
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        floating: false,
        tickAmount: 15,
        tickPlacement: 'on',
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
          offsetX: 0,
          offsetY: 0,
          format: 'dd/MM',
          formatter: function (value, timestamp, opts) {
            return dayjs(value).format('DD-MM')
          },
          datetimeUTC: false,
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'dd MMM',
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
                ?.x
            ).format('DD-MMMM-YYYY')
          },
        },
      },
    },
  })

  const DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.id

  useEffect(() => {
    setSelectedDeviceID(DEVID)
    setSelectedButtons([`ActualGeneration`])
    handleSelectInverter(
      'etoday',
      '1m',
      DEVID,
      selectedTypeID,
      technicalFromDate,
      technicalToDate,
      token
    )
  }, [DEVID])

  useEffect(() => {
    handleChangePreiod(inverterviewbutton, technicalFromDate)
  }, [inverterviewbutton, technicalFromDate, technicalToDate])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSelectInverter = (
    type,
    duration,
    deviceID,
    typeID,
    selectedDate,
    selectedtoDate,
    token
  ) => {
    let fromDate;
    let toDate;

    const today = dayjs();
    
    //date formatting
    switch (duration) {
      case 'year':
        fromDate = today.format('YYYY-MM-DD');
        toDate = 'all';
          break;
        
        case '1m':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case '3m':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case '6m':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case 'mtd':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case 'ytd':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case 'day':
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
          break;
        
        case 'custom':
          fromDate = dayjs(selectedDate).format('YYYY-MM-DD');
          toDate = dayjs(selectedtoDate).format('YYYY-MM-DD');
          break;
        
        default:
          fromDate = today.format('YYYY-MM-DD');
          toDate = 'all';
      }

      const sortDate = fromDate;

      setIsLoading(true);

      //normalise datatypes
      const lcType = String(type || '').toLowerCase();
      let apiType = lcType;
      if (lcType === 'minimumguaranteed' || lcType.includes('minimum')) {
        apiType = 'minimumguarantee';
      } else if (lcType === 'expectedgeneration' || lcType.includes('expected')) {
        apiType = 'expectedgeneration';
      } else if (lcType === 'etoday') {
        apiType = 'etoday';
      } 

      let seriesName = lcType === 'etoday' ? 'ActualGeneration' :
                      lcType.includes('minimum') ? 'MinimumGuaranteed' :
                      lcType.includes('expected') ? 'ExpectedGeneration' :
                      type;

      const devIdForApi = deviceID && deviceID !== '' ? deviceID : 'all';
      const toDateForApi = toDate || 'all';

      /*console.log('API Request:', {
        plantId: PlantID,
        dataType: apiType,
        fromDate: sortDate,
        period: duration,
        toDate: toDateForApi,
        deviceId: devIdForApi
      });*/

      fetchGraphV2Data(PlantID, apiType, sortDate, duration, token, 'all', toDateForApi, devIdForApi)
        .then((resp) => {
          const dataArray = resp?.data ?? resp ?? [];

          const newSeriesData = dataArray.map((obj) => ({
            x: obj.x,
            y: Number(parseFloat((obj.y || 0)).toFixed(1)),
          }));

          setMapinverterData(newSeriesData);
          setMapInverterSeries((prevSeries) => {
            const existingObject = prevSeries.find((obj) => obj.name === seriesName);

            if (existingObject) {
              const updatedObject = {
                ...existingObject,
                data: newSeriesData,
              };

              return prevSeries.map((obj) =>
                obj.name === seriesName ? updatedObject : obj
              );
            } else {
              const newObject = {
                name: seriesName,
                data: newSeriesData,
              };
              return [...prevSeries, newObject];
            }
          });
        })
        .catch((err) => {
          console.error('Unable to fetch Graph V2 data:', err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };


  const separateValues = (str) => {
    const [label, value] = str.split(' ') // Split the string into two parts using the space as a separator
    return { label, value }
  }

  const handleChangePreiod = (Period, selectedDate) => {
    selectedButtons.map((item) => {
      const { label, value } = separateValues(item)

      let devtype
      if (label === 'ActualGeneration') {
        devtype = 'etoday'
      } else if (label === 'MinimumGuaranteed') {
        devtype = 'MinimumGuaranteed'
      } else if (label === 'ExpectedGeneration') {
        devtype = 'expectedgeneration'
      }
      handleSelectInverter(
        devtype,
        Period,
        selectedDeviceID,
        selectedTypeID,
        selectedDate,
        technicalToDate,
        token,
      )
    })
  }

  

    const handleChooseDate = (value, type) => {
  if (type === 'from') {
    setTechnicalFromDate(value);
  } else if (type === 'to') {
    setTechnicalToDate(value);
  }
  // Ensure 'to' date is not before 'from' date
  if (type === 'to' && dayjs(value).isBefore(technicalFromDate)) {
    setTechnicalFromDate(value);
    setTechnicalToDate(technicalFromDate);
  }
};

  const handleselectButton = (ButtonType) => {
    switch (ButtonType) {
      case 'year':
        const yearData = dayjs(technicalFromDate).add(11, 'month')
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year', previous1yData)
        } else {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year', previous1yData)
        }

        break
      case '1m':
        const monthData = dayjs(technicalFromDate).add(29, 'day')
        const currentDate1 = dayjs()
        const isFuture1 = monthData.isAfter(currentDate1)
        if (isFuture1) {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m', previous1Data)
        } else {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m', previous1Data)
        }
        break
      case '3m':
        const month3Data = dayjs(technicalFromDate).add(2, 'month')
        const currentDate = dayjs()
        const isFuture = month3Data.isAfter(currentDate)
        if (isFuture) {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m', previous3Data)
        } else {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m', previous3Data)
        }
        break
      case '6m':
        const month6Data = dayjs(technicalFromDate).add(5, 'month')
        const currentDate6 = dayjs()
        const isFuture6 = month6Data.isAfter(currentDate6)
        if (isFuture6) {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('6m')
          handleChangePreiod('6m', previous6Data)
        } else {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('6m')
          handleChangePreiod('6m', previous6Data)
        }
        break
      case 'mtd':
        const firstDateOfMonth = dayjs(new Date()).startOf('month')
        const mtdData = dayjs(new Date()).subtract(1, 'month')
        setTechnicalFromDate(firstDateOfMonth)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('mtd')
        handleChangePreiod('mtd', dayjs(new Date()))

        break
      case 'ytd':
        const firstDateOfYear = dayjs(new Date()).startOf('year')
        const ytdData = dayjs(new Date()).subtract(1, 'year')
        setTechnicalFromDate(firstDateOfYear)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('ytd')
        handleChangePreiod('ytd', dayjs(new Date()))

        break
      case 'custom':
        const customFromdate = dayjs(technicalFromDate).format('YYYY-MM-DD')
        const customTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
        setinverterviewbutton('custom')
        handleChangePreiod('custom', customFromdate, customTodate)
        break
      default:
        break
    }
  }

  const handleInverterViewSort = (type) => {
    if (type === 'year') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('year')
    } else if (type === '1m') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('DD-MM')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('1m')
    } else if (type === '3m') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('3m')
    } else if (type === '6m') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('6m')
    } else if (type === 'ytd') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMMM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('MMM-YY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('ytd')
    } else if (type === 'mtd') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('DD-MM')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MMM-YYYY')
              },
            },
          },
        },
      })
      handleselectButton('mtd')
    } else if (type === 'custom') {
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'EnergyAnalysis',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'EnergyAnalysis',
                },
                png: {
                  filename: 'EnergyAnalysis',
                },
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: [
            '#6CB759',
            '#5968B7',
            '#dc3545',
            '#F5B041',
            '#BB8FCE',
            '#CCCCFF',
          ],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value, timestamp, opts) {
                return dayjs(value).format('DD/MM')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MM-YYYY')
              },
            },
          },
        },
      })

      handleselectButton('custom')
    }
  }

  const handleButtonClick = (buttonName, deviceID, typeID) => {
    if (selectedButtons.includes(`${buttonName}`)) {
      // If the button is already selected, remove it from the selected buttons
      setSelectedButtons(
        selectedButtons.filter((btn) => btn !== `${buttonName}`)
      )

      setMapInverterSeries(
        (prevSeries) => prevSeries.filter((obj) => obj.name !== `${buttonName}`) // Specify the name of the object to remove
      )
    } else {
      // If the button is not selected, check if the limit of 2 buttons is reached
      // if (selectedButtons.length < 2) {
      // Add the button to the selected buttons
      setSelectedButtons([...selectedButtons, `${buttonName}`])
      setSelectedDeviceID(deviceID)
      setSelectedTypeID(typeID)
      let devtype
      if (buttonName === 'ActualGeneration') {
        devtype = 'etoday'
      } else if (buttonName === 'MinimumGuaranteed') {
        devtype = 'MinimumGuaranteed'
      } else if (buttonName === 'ExpectedGeneration') {
        devtype = 'expectedgeneration'
      }
      setGraphType(devtype)
      handleSelectInverter(
        devtype,
        inverterviewbutton,
        deviceID,
        typeID,
        technicalFromDate,
        technicalToDate,
        token,
      )
    }
  }

  const columns = [
    { field: 'x', headerName: 'Date', width: 100 },
    { field: 'y', headerName: 'Yield', width: 100 },
  ]

  const exportToCSV = (rows) => {
    const headings = ['Date', ...rows.map((item) => item.name)] // Add 'Date' and 'name' properties as headings
    const csvContent = [headings.join(',')]

    const allDates = new Set()
    rows.forEach((item) =>
      item.data.forEach((row) =>
        allDates.add(dayjs(row.x).format('DD-MM-YYYY'))
      )
    )

    allDates.forEach((date) => {
      const rowData = [date]
      rows.forEach((item) => {
        const dataForDate = item.data.find(
          (row) => dayjs(row.x).format('DD-MM-YYYY') === date
        )
        rowData.push(dataForDate ? dataForDate.y : 0)
      })
      csvContent.push(rowData.join(','))
    })

    const blob = new Blob([csvContent.join('\n')], {
      type: 'text/csv;charset=utf-8',
    })
    saveAs(blob, 'EnergyAnalysis.csv')
  }
  const datePickerStyle = {
    width: '130px',
  }

  const dynamicHeadings = mapInverterSeries.map((item) => item.name)

  return (
    <div className={classes.root}>
      <div
        className="graph_bg mb_10"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <div className="align_btw mb_6">
          <div>
            <div className="h_txt1">Energy Analysis</div>
          </div>

          <div>
            <div className="align_end">
              <div class="check_graph mr_8">
                <input
                  id="EnergyAnalysisGraph"
                  type="checkbox"
                  checked={openTable}
                  onChange={(e) => setOpenTable(!openTable)}
                />
                <label for="EnergyAnalysisGraph"></label>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="From Date"
                        minDate={dayjs(new Date()).subtract(2, 'year')}
                        maxDate={
                          inverterviewbutton === 'custom'
                            ? technicalToDate
                            : dayjs()
                        }
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalFromDate}
                        onChange={(value) => handleChooseDate(value, 'from')}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="To Date"
                        minDate={
                          inverterviewbutton === 'custom'
                            ? technicalFromDate
                            : dayjs(new Date()).subtract(2, 'year')
                        }
                        maxDate={dayjs()}
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalToDate}
                        onChange={(value) => handleChooseDate(value, 'to')}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              {openTable && (
                <div className="mr_8">
                  <VerticalAlignBottomIcon
                    className="i_clr pointer"
                    onClick={() => exportToCSV(mapInverterSeries)}
                  />
                </div>
              )}
              <div>
                <FullscreenIcon
                  className="i_clr pointer"
                  onClick={handleOpen}
                />
              </div>

              <Dialog fullScreen open={open} onClose={handleClose}>
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogTitle></DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <div className="graph_bg">
                      <div className="align_btw mb_10">
                        <div>
                          <div className="h1">Energy Analysis</div>
                        </div>

                        <div className={classes.root}>
                          <div className="align_end">
                            <div class="check_graph mr_8">
                              <input
                                id="EnergyAnalysisGraph2"
                                type="checkbox"
                                checked={openTable}
                                onChange={(e) => setOpenTable(!openTable)}
                              />
                              <label for="EnergyAnalysisGraph2"></label>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="From Date"
                                    minDate={dayjs(new Date()).subtract(
                                      2,
                                      'year'
                                    )}
                                    maxDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalToDate
                                        : dayjs()
                                    }
                                    format="DD-MM-YYYY"
                                    value={technicalFromDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'from')
                                    }
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="To Date"
                                    minDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalFromDate
                                        : dayjs(new Date()).subtract(2, 'year')
                                    }
                                    maxDate={dayjs()}
                                    format="DD-MM-YYYY"
                                    value={technicalToDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'to')
                                    }
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>

                            {openTable && (
                              <div className="mr_8">
                                <VerticalAlignBottomIcon
                                  className="i_clr pointer"
                                  onClick={() =>
                                    exportToCSV(
                                      mapInverterSeries[0]?.data,
                                      columns
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="align_btw mb_6">
                        <div
                          className=""
                          style={{
                            width: '30%',
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`ActualGeneration`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(`ActualGeneration`, '', 1)
                            }
                          >
                            Actual Generation
                          </div>
                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`MinimumGuaranteed`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(`MinimumGuaranteed`, '', 1)
                            }
                          >
                            Minimum Guaranteed
                          </div>
                          <div
                            className="head_button mr_8"
                            style={
                              isButtonSelected(`ExpectedGeneration`)
                                ? {
                                    backgroundColor: 'rgba(89, 104, 183, 0.25)',
                                  }
                                : {}
                            }
                            onClick={() =>
                              handleButtonClick(`ExpectedGeneration`, '', 1)
                            }
                          >
                            Expected Generation
                          </div>
                        </div>

                        <div>
                          <div
                            className={
                              inverterviewbutton === 'custom'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('custom')}
                          >
                            CUST
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'ytd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('ytd')}
                          >
                            YTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'mtd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('mtd')}
                          >
                            MTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'year'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('year')}
                          >
                            1 Y
                          </div>
                          <div
                            className={
                              inverterviewbutton === '6m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('6m')}
                          >
                            6 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '3m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('3m')}
                          >
                            3 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '1m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('1m')}
                          >
                            1 M
                          </div>
                        </div>
                      </div>
                      {openTable ? (
                        <div style={{ maxHeight: '360px', overflow: 'auto' }}>
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  {dynamicHeadings?.map((heading, index) => (
                                    <TableCell key={index}>{heading}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {mapInverterSeries?.[0]?.data?.map(
                                  (row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                      <TableCell>
                                        {dayjs(row.x).format('DD-MM-YYYY')}
                                      </TableCell>
                                      {mapInverterSeries?.map((item, index) => (
                                        <TableCell key={index}>
                                          {item.data.find(
                                            (entry) => entry.x === row.x
                                          )?.y || 0}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <div
                              style={{
                                color: '#5968B7',
                                fontSize: '12px',
                                marginLeft: '5px',
                              }}
                            >
                              kWh
                            </div>
                          </div>
                          <div id="chart">
                            <ReactApexChart
                              options={lineData.options}
                              series={mapInverterSeries}
                              legend={lineData.legend}
                              type="line"
                              height={screenHeight - 200}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
        <div className="align_btw mb_6">
          <Grid container>
            <Grid md={6}>
              <div className=" ">
                <div>
                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`ActualGeneration`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() => handleButtonClick(`ActualGeneration`, '', 1)}
                  >
                    Actual Generation
                  </div>
                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`MinimumGuaranteed`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() =>
                      handleButtonClick(`MinimumGuaranteed`, '', 1)
                    }
                  >
                    Minimum Guaranteed
                  </div>
                  <div
                    className={`head_button`}
                    style={
                      isButtonSelected(`ExpectedGeneration`)
                        ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                        : {}
                    }
                    onClick={() =>
                      handleButtonClick(`ExpectedGeneration`, '', 1)
                    }
                  >
                    Expected Generation
                  </div>
                </div>
              </div>
            </Grid>
            <Grid md={6} style={{ display: 'flex', justifyContent: 'end' }}>
              <div>
                <div
                  className={
                    inverterviewbutton === 'custom'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('custom')}
                >
                  CUST
                </div>
                <div
                  className={
                    inverterviewbutton === 'ytd'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('ytd')}
                >
                  YTD
                </div>
                <div
                  className={
                    inverterviewbutton === 'mtd'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('mtd')}
                >
                  MTD
                </div>
                <div
                  className={
                    inverterviewbutton === 'year'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('year')}
                >
                  1 Y
                </div>
                <div
                  className={
                    inverterviewbutton === '6m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('6m')}
                >
                  6 M
                </div>
                <div
                  className={
                    inverterviewbutton === '3m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('3m')}
                >
                  3 M
                </div>
                <div
                  className={
                    inverterviewbutton === '1m'
                      ? 'day_s_bottomline'
                      : 'day_s_b '
                  }
                  onClick={() => handleInverterViewSort('1m')}
                >
                  1 M
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {isLoading ? (
          <div
            style={{
              padding: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              marginTop: '100px',
            }}
          >
            <LinearBuffer />
          </div>
        ) : openTable ? (
          <div style={{ maxHeight: '360px', overflow: 'auto' }}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    {dynamicHeadings?.map((heading, index) => (
                      <TableCell key={index}>{heading}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mapInverterSeries?.[0]?.data?.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell>{dayjs(row.x).format('DD-MM-YYYY')}</TableCell>
                      {mapInverterSeries?.map((item, index) => (
                        <TableCell key={index}>
                          {item.data.find((entry) => entry.x === row.x)?.y || 0}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          <div>
            <div>
              <div
                style={{
                  color: '#5968B7',
                  fontSize: '12px',
                  marginLeft: '5px',
                }}
              >
                kWh
              </div>
            </div>
            <div id="chart">
              <ReactApexChart
                options={lineData.options}
                series={mapInverterSeries}
                legend={lineData.legend}
                type="line"
                height={350}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

EnergyAnalysisGraph.propTypes = {}

export default EnergyAnalysisGraph